import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import {IonicStorageModule} from '@ionic/storage';

//Angular Material
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

//GoogleMap
import { GoogleMaps } from '@ionic-native/google-maps/ngx';

//Traducciones
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { InterceptorService } from './services/interceptor.service';
import { AlertController } from '@ionic/angular';
import { PayPal } from '@ionic-native/paypal/ngx';
import localeFr from '@angular/common/locales/fr';
import { registerLocaleData } from '@angular/common';
registerLocaleData(localeFr, 'fr');


//Autenticacion
import { PaypalPage } from './pages/paypal/paypal.page';
import { PaypalWebPage } from './pages/paypal-web/paypal-web.page';
import { StripePage } from './pages/stripe/stripe.page';



@NgModule({
	declarations: [AppComponent,PaypalPage, PaypalWebPage,StripePage],
	entryComponents: [PaypalPage, PaypalWebPage,StripePage],
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		IonicModule.forRoot(),
		IonicStorageModule.forRoot(),
		HttpClientModule,
		AppRoutingModule,
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: (createTranslateLoader),
				deps: [HttpClient],
			}
		})
	],
	providers: [
		StatusBar,
		SplashScreen,
		GoogleMaps,
		PayPal,
		AlertController,
		{
			provide: RouteReuseStrategy, 
			useClass: IonicRouteStrategy
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: InterceptorService,
			multi: true
		}
	],
	bootstrap: [AppComponent]
})
export class AppModule {}

export function createTranslateLoader(http: HttpClient) {
	return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}